import React from "react";
import { Card, DataTable, HighlightMatch, Table, } from "@sscs/ui";
import { formatDistanceToNow } from "date-fns";
import { SECRET_LIVENESS_SHORT_LABEL } from "../../../../constants";
import { SECRET_LIVENESS_DESCRIPTION } from "../../../utils";
import styles from "./endpointsTable.module.scss";
const COLUMNS = [
    { id: "liveness", label: "Liveness", width: "100px" },
    { id: "label", label: "Label", width: "200px" },
    { id: "url", label: "URL", width: "50%" },
    { id: "details", label: "Details", width: "50%" },
];
const EndpointsTable = ({ endpoints, endpointLabelHighlight, liveness, scanTime, }) => {
    if (liveness === "skipped") {
        return (React.createElement(Card.Card, null,
            React.createElement(Card.Title, null, "Liveness check"),
            React.createElement(Card.Content, null, "Skipped")));
    }
    if (!endpoints.length) {
        return (React.createElement(Card.Card, null,
            React.createElement(Card.Title, null, "Liveness check"),
            React.createElement(Card.Content, null, "Not performed: No matching verifiers")));
    }
    return (React.createElement(DataTable, { columns: COLUMNS, chrome: "card", title: "Liveness check", titleDetails: [
            React.createElement("span", { key: "performed" },
                "Performed",
                " ",
                scanTime ? (React.createElement("span", { title: scanTime }, formatDistanceToNow(new Date(scanTime), {
                    addSuffix: true,
                }))) : ("/")),
        ] }, endpoints.map((endpoint, index) => (React.createElement(Table.Row, { key: index },
        React.createElement(Table.Cell, { className: endpoint.liveness === "active" ? styles["active"] : undefined }, SECRET_LIVENESS_SHORT_LABEL[endpoint.liveness]),
        React.createElement(Table.Cell, null, endpointLabelHighlight ? (React.createElement(HighlightMatch, { value: endpoint.label, regex: endpointLabelHighlight })) : (endpoint.label)),
        React.createElement(Table.Cell, null, endpoint.location),
        React.createElement(Table.Cell, null, endpoint.error || SECRET_LIVENESS_DESCRIPTION[endpoint.liveness]))))));
};
export default EndpointsTable;
//# sourceMappingURL=EndpointsTable.js.map